(() => {
  const sync = info => {
    const selected = info.querySelector('.ot-estimated-shipping .ot-selected-rule input');
    const rules = window.estimatedAppMetafields?.data?.rules;
    const rule = Array.isArray(rules) ? rules.find(rule => String(rule.id) === selected?.value) : null;
    const country = info.querySelector('.ot-estimated-shipping-country-select-box-country')?.value;
    const productScoped = rule?.calculationMode === 'manual'
      && !rule.isUsePreOrderDate && !rule.isCountInventoryQuantityFromLocations
      && !rule.shippingMethodConditions && rule.itemConditions?.length > 0
      && rule.itemConditions.every(condition => condition.type === 'collections_applied')
      && rule.locationConditions?.every(condition => condition.type === 'country'
        && condition.value.some(value => value.data === country));
    const variant = info.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
    const text = info.querySelector('.ot-estimated-shipping .ot-selected-rule .ot-estimated-shipping-text-shipping');
    const value = productScoped && variant?.value && !variant.disabled && text && text.getClientRects().length
      ? text.textContent.replace(/\s+/g, ' ').trim() : '';
    info.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(form => {
      let field = form.querySelector('[data-fm-delivery-property]');
      if (!field) {
        field = document.createElement('input');
        field.type = 'hidden';
        field.name = 'properties[Lieferfenster]';
        field.dataset.fmDeliveryProperty = '';
        form.append(field);
      }
      if (field.value !== value) field.value = value;
      field.disabled = !value;
      field.dataset.fmDeliveryVariant = value ? variant.value : ''; 
    });
    return value;
  };
  document.querySelectorAll('[id^="ProductInfo-"]').forEach(info => {
    let pending = false;
    const schedule = () => {
      if (pending) return;
      pending = true;
      requestAnimationFrame(() => { pending = false; sync(info); });
    };
    new MutationObserver(schedule).observe(info, {subtree:true, childList:true, characterData:true, attributes:true, attributeFilter:['class','style','hidden']});
    info.addEventListener('change', event => {
      if (event.target.closest('variant-selects')) {
        info.querySelectorAll('[data-fm-delivery-property]').forEach(field => {
          field.value = ''; field.disabled = true;
        });
      }
      schedule();
    });
    info.addEventListener('formdata', event => {
      const value = sync(info);
      if (value) event.formData.set('properties[Lieferfenster]', value);
      else event.formData.delete('properties[Lieferfenster]');
    });
    sync(info);
  });
})();
